<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="content-chapter1x ParaOverride-1" id="_idParaDest-3"><a href="#/BlackAndResilient3#_idTextAnchor000">This Is Your Time to Shine<span id="_idTextAnchor028"></span> </a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// BlackAndResilient4.vue?118ebdef